<template>
  <custom-dialog width="480px" :title="title" class="company-seal-item-dialog" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col>
            <el-form-item :label="$t('crm_company_seal_item_dialog.yin_zhang_ming_cheng')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('crm_company_seal_item_dialog.shi_fou_mo_ren')" prop="isDefault">
              <el-switch v-model="form.isDefault" :active-value="true" :inactive-valuue="false"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('crm_company_seal_item_dialog.yin_zhang_tu_pian')">
              <t-upload :limit="4" :bizId="bizId" :bizType="bizType" v-model="picList" :tip="tip" :autoUpload="false" ref="crmPartnerSeal"></t-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import tUpload from '@/components/upload.vue';

export default {
  components: {
    tUpload,
  },
  props: {
    type: {
      type: String,
      default: 'add',
    },
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
      };
    },
    title() {
      return this.type === 'add' ? this.$t('crm_company_seal_item_dialog.tian_jia_yin_zhang') : this.$t('crm_company_seal_item_dialog.bian_ji_yin_zhang');
    },
    tip() {
      return this.getTips();
    },
  },
  data() {
    return {
      visible: true,
      bizId: '',
      bizType: 'crm.partner.seal',
      picList: [],
      form: {
        // 印章名称
        name: '',
        // 是否默认
        isDefault: true,
      },
    };
  },
  methods: {
    getTips() {
      return this.$t('crm_company_seal_item_dialog.1yztpccqazpbjsxwtmds');
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {},
  },
};
</script>

<style lang="scss" scoped></style>
